import { render, staticRenderFns } from "./couponSuccModal.vue?vue&type=template&id=63dc7ed0&scoped=true&"
import script from "./couponSuccModal.vue?vue&type=script&lang=js&"
export * from "./couponSuccModal.vue?vue&type=script&lang=js&"
import style0 from "./couponSuccModal.vue?vue&type=style&index=0&id=63dc7ed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc7ed0",
  null
  
)

export default component.exports